import {
  CART_ADD_ITEM,
  CART_CLEAR,
  CART_REPLACE_ITEMS,
  CART_REMOVE_ITEM,
  CART_UPDATE_QUANTITY,
} from './actionTypes';

export const cartActions = {
  addItem: (product, quantity = 1) => ({ type: CART_ADD_ITEM, payload: { product, quantity } }),
  removeItem: (id) => ({ type: CART_REMOVE_ITEM, payload: id }),
  updateQuantity: (id, quantity) => ({ type: CART_UPDATE_QUANTITY, payload: { id, quantity } }),
  clearCart: () => ({ type: CART_CLEAR }),
  replaceItems: (items = []) => ({ type: CART_REPLACE_ITEMS, payload: { items } }),
};
